import { render, staticRenderFns } from "./bullAvgAgeFirstCollection.vue?vue&type=template&id=10795298&scoped=true&"
import script from "./bullAvgAgeFirstCollection.vue?vue&type=script&lang=js&"
export * from "./bullAvgAgeFirstCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10795298",
  null
  
)

export default component.exports